module.exports = __webpack_public_path__ + "img/1675143770257-pNifja_p.b8288e29.webp";